import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

interface SettingsUIState {
    tab: string;
    option: string;
}

const initialState: SettingsUIState = {
    tab: '',
    option: '',
};

const settingsUISlice = createSlice({
    name: 'settingsUI',
    initialState,
    reducers: {
        setTabAndOption: (state, action: PayloadAction<{ tab: string; option: string }>) => {
            state.tab = action.payload.tab;
            state.option = action.payload.option;
        },
    },
});

export const { setTabAndOption } = settingsUISlice.actions;

export const setTab = (tab: string) => settingsUISlice.actions.setTabAndOption({ tab, option: '' });

export const closeSettingsUI = () => settingsUISlice.actions.setTabAndOption({ tab: '', option: '' });

export const selectSettingsTab = (state: RootState) => state.settingsUI.tab;
export const selectSettingsOption = (state: RootState) => state.settingsUI.option;

export default settingsUISlice.reducer;